/** Values that represent an unfinished grid filter. Zero and false are valid values. */
export function isEmptyGridFilterValue(value: unknown): boolean {
	return (
		value == null ||
		value === '' ||
		(typeof value === 'number' && Number.isNaN(value)) ||
		(Array.isArray(value) && value.length === 0)
	);
}
